import script from "./AppMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMobile.vue?vue&type=script&setup=true&lang=ts"

import "./AppMobile.vue?vue&type=style&index=0&id=ba1f8046&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba1f8046"]])

export default __exports__